import { baseRoutes } from '@routes/helpers/baseRoutes.ts';
import { routesPaths } from '@routes/helpers/constants.ts';
import { AppRouteConfig } from '@routes/route';

export const workspaceRoutes: ReadonlyArray<AppRouteConfig> = [
  {
    path: baseRoutes.workspace.root,
    lazyImport: () => import('../../domains/protected/workspace/WorkspaceRoute.tsx'),
    requiresAuth: true,
    resourceId: 'workspace-docket',
    children: [
      {
        index: true,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/workspace/workspace-grid/WorkspaceGridRoute.tsx'),
        nav: {
          hideBack: true,
          breadcrumbKey: 'list'
        }
      },
      {
        path: baseRoutes.workspace.history,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/history/history-list/WorkspaceHistoryRoute.tsx'),
        nav: {
          backTo: routesPaths.workspace.root,
          breadcrumbKey: 'history'
        }
      },
      {
        path: baseRoutes.workspace.details,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/workspace/workspace-details/WorkspaceDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.workspace.root,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.workspace.historyDetails,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/history/history-details/WorkspaceHistoryDetailsRoute.tsx'),
        nav: {
          backTo: routesPaths.workspace.history,
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.workspace.newResponse,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/response/SurveyResponseRoute.tsx'),
        nav: {
          backTo: routesPaths.workspace.details(':id'),
          breadcrumbKey: 'details'
        }
      },
      {
        path: baseRoutes.workspace.responseDetails,
        lazyImport: () =>
          import('../../domains/protected/workspace/pages/response/SurveyResponseRoute.tsx'),
        nav: {
          backTo: routesPaths.workspace.details(':id'),
          breadcrumbKey: 'details'
        }
      },
      {
        path: '*',
        redirectTo: baseRoutes.workspace.root
      }
    ]
  }
];
